export const en = {
  form: {
    localeForm: {
      buttons: {
        submit: {
          label: 'Apply',
        },
      },
    },
    newsletterForm: {
      buttons: {
        submit: {
          label: 'Sign up',
        },
      },
      outcome: {
        success: {
          body: 'Congratulations from now on you are also part of the BB Skill world!',
          buttons: {
            ok: {
              label: 'Ok',
            },
          },
          title: 'You successfully signed up to our newsletter',
        },
      },
    },
  },
  misc: {
    addToCart: 'Add to cart',
    assembledProduct: {
      configure: 'Configure',
      selectAllComponent: 'Select all products',
      selectComponent: 'Select your shade',
    },
    outOfStock: 'Out of stock',
    storeName: 'BB Skill',
    variant: {
      color: 'Color',
      size: 'Size',
    },
  },
  play: 'Play',
  product: {
    code: 'Cod',
    freeShippingFrom: '<strong>Free shipping</strong> from {{freeShippingFromAmount}}',
    promo: 'Promo',
    relatedProduct: {
      title: 'You may also like',
    },
    selectSize: 'Select color',
    size: 'Format',
    size_one: 'Color',
    size_other: 'Colors',
  },
  productPage: {
    measurement: '<strong>Format</strong> {{value}} {{measurementUnit}}',
  },
  welcome: 'Welcome to BB Skill',
};
